// import _ from "lodash";

let breakpoints = {
  xs: 575,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
};

let instance = {
  index: 0,
  breakpoints,
  resizeListeners: {},
  binded: {},
  _vnodes: {},
};

/**
 * v-rwd="{show: [], hidden: [], class: []}"
 *
 * [show on point]
 * v-rwd="'xs'"
 * v-rwd="['xs', 'lg']"
 * v-rwd.up.and="'xs'"
 * v-rwd.down="'lg'"
 *
 * [hidden on point]
 * v-rwd:hidden="'xs'"
 * v-rwd:hidden="['xs', 'sm']"
 * v-rwd:hidden.up="'xs'"
 * v-rwd:hidden.down="'md'"
 *
 * [add class]
 * v-rwd:class="{xs:{}}"
 */
let vueRwd = {
  bind: (el, binding) => {
    // increment id
    let id = instance.index++;

    let { value, modifiers } = binding;
    let arg = !binding.arg ? "show" : binding.arg;

    modifiers = Object.keys(modifiers);

    if (!modifiers.length) {
      modifiers = ["only"];
    }

    if (typeof value === "string") {
      value = [value];
    }

    let params = {};
    let bps = Object.keys(instance.breakpoints);

    if (modifiers.indexOf("only") > -1) {
      bps.forEach((bp) => {
        if (arg === "show") {
          params[bp] = value.indexOf(bp) > -1;
        } else {
          params[bp] = !(value.indexOf(bp) > -1);
        }
      });
    } else if (modifiers.indexOf("up") > -1) {
      bps.forEach((bp, index) => {
        value = value[0];
        params[bp] = modifiers.indexOf("and")
          ? index >= bps.indexOf(value) && arg === "show"
          : index > bps.indexOf(value) && arg === "show";
      });
    } else if (modifiers.indexOf("down") > -1) {
      bps.forEach((bp, index) => {
        value = value[0];
        params[bp] = modifiers.indexOf("and")
          ? index <= bps.indexOf(value) && arg === "show"
          : index < bps.indexOf(value) && arg === "show";
      });
    } else {
      bps.forEach((bp) => {
        params[bp] = arg === "show";
      });
    }

    el.dataset.rwd = id;
    instance.binded[id] = params;
    instance._vnodes[id] = el.innerHtml;

    // adds a single resize listener for all elements
    window.addEventListener("resize", function() {
      // calls the checkDisplay function for all elements that are active in the DOM and use this directive
      for (let i in instance.resizeListeners)
        if (!isNaN(i)) instance.resizeListeners[i]();
    });
  },

  inserted: (el, binding, vnode) => {
    if (el.dataset.rwd == null) return;

    let id = el.dataset.rwd;

    let handler = (instance.resizeListeners[id] = () => {
      let params = instance.binded[id];
      let sWidth = screen.width;
      let bps = instance.breakpoints;

      for (let point in bps) {
        let inPoint =
          point === "xs" ? sWidth <= bps[point] : sWidth > bps[point];

        if (inPoint) {
          let show = params[point];

          if (!show) {
            const comment = document.createComment(" ");
            Object.defineProperty(comment, "setAttribute", {
              value: () => undefined,
            });
            // vnode.elm = comment;
            // vnode.text = " ";
            vnode.isComment = true;
            // vnode.context = undefined;
            // vnode.tag = undefined;
            // vnode.data.directives = undefined;
            // el.innerHtml = comment;
            // if (vnode.componentInstance) {
            //   vnode.componentInstance.$el = comment;
            // }

            // if (el.parentNode) {
            //   el.parentNode.replaceChild(comment, el);
            // }
          } else {
            vnode.isComment = false;
          }
        }
      }
    });
    handler();
  },
  install: (Vue, options) => {
    if (typeof options === "object" && options.breakpoints) {
      instance.breakpoints = options.breakpoints;
    }
    Vue.directive("rwd", vueRwd);
  },
};

export { vueRwd };
export default vueRwd;
